import CommonButton from "../button";

/**
 * Button Switches Based On The Passed Payments States
 * @returns JSX.Element
 */
export default function SanaamPaymentAction({ sanaamPayment, action, loading, text, ...props }) {
  const defaultProps = {
    onClick: action ? action : () => { }
  }
  if (sanaamPayment?.state === "PENDING") {
    return (
      <CommonButton
        disabled={loading}
        text={text || "Settle"}
        {...defaultProps}
        loading={loading}
      />
    )
  }
  return (<div>
    <CommonButton
      disabled={true}
      text={text || "Settle"}
      loading={loading}
    />
  </div>)
}